import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './PeopleFinderSearch.css';
import { PeopleFinderStore } from '../stores/PeopleFinderStore';
import { IAIcon } from '../../icon/Icon';
import { IAPersonaImage } from '../../personaImage/PersonaImage';
import { Environment } from '../../../services/Environment';
import { Helper } from '../../../Helper';
import { ConditionalOutput } from '../../../services/ConditionalOutput';
import { LocalizationService } from '../../../services/LocalizationService';

export interface IPeopleFinderSearchProps {
  peopleFinderStore?: PeopleFinderStore;
}

@inject('peopleFinderStore')
@observer
export class PeopleFinderSearch extends React.Component<IPeopleFinderSearchProps> {
  private ref = React.createRef<HTMLInputElement>();

  public render() {
    const searchResult = this.props.peopleFinderStore.searchedResults?.slice(0, 10) || [];
    const loadingIconOrShowMorebutton = 30;
    return (
      <React.Fragment>
        <div className={styles.IA_peopleFinder_body_searchAndFilterWrapper}>
          <div className={styles.IA_peopleFinder_searchInput}>
            <input
              ref={this.ref}
              aria-label={new LocalizationService().strings.PeopleFinder_FindColleagues}
              placeholder={new LocalizationService().strings.PeopleFinder_FindColleagues}
              onChange={(e) => {
                this.props.peopleFinderStore.searchValue = e.target.value;
                if (!this.props.peopleFinderStore.showMore) {
                  if (!!e.target.value) {
                    this.props.peopleFinderStore.showResultList = true;
                  } else {
                    this.props.peopleFinderStore.showResultList = false;
                  }
                }
                this.props.peopleFinderStore.getSearched();
              }}
              value={this.props.peopleFinderStore.searchValue}
            />
            {this.props.peopleFinderStore.showMore && this.props.peopleFinderStore.isFetchingSearchResults && (
              <div className={styles.IA_peopleFinder_searchInputSpinner}>
                <div style={{ width: 25 }}>
                  <div
                    className={styles.IA_peopleFinder_searchInputListCardSpinner}
                    style={{
                      padding: 0,
                    }}
                  >
                    <IAIcon title="Spinner" size={18} color={this.props.peopleFinderStore.design.colors.iconColor} />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className={styles.IA_peopleFinder_body_filterButton}
            onClick={() => {
              this.props.peopleFinderStore.showFilter = !this.props.peopleFinderStore.showFilter;
            }}
          >
            <IAIcon title="Filter" size={20} color={this.props.peopleFinderStore.design.colors.iconColor} style={{ margin: 'auto 0px auto 5px' }} />
            <input readOnly type="Submit" value="Filter" />
          </div>
        </div>
        <div className={styles.IA_peopleFinder_searchValueListWrapper}>
          {this.props.peopleFinderStore.showResultList && (
            <div
              className={styles.IA_peopleFinder_searchInputList}
              style={{
                height: new ConditionalOutput(0)
                  .OnCondition(this.props.peopleFinderStore.showResultList && searchResult.length === 0, loadingIconOrShowMorebutton)
                  .OnCondition(this.props.peopleFinderStore.showResultList && searchResult.length > 0, searchResult.length * 50)
                  .OnCondition(this.props.peopleFinderStore.showResultList && searchResult.length === 10, searchResult.length * 50 + loadingIconOrShowMorebutton)
                  .Last(),
              }}
            >
              {this.props.peopleFinderStore.showResultList && (
                <React.Fragment>
                  {searchResult?.map((person, index) => {
                    return (
                      <div
                        key={index}
                        className={styles.IA_peopleFinder_searchInputListCard}
                        onClick={() => {
                          this.props.peopleFinderStore.selectedPerson = person;
                          this.props.peopleFinderStore.openPanel(person);
                        }}
                      >
                        <div className={styles.IA_peopleFinder_searchInputListCardImage}>
                          <IAPersonaImage
                            backgroundColor={this.props.peopleFinderStore.design.colors.mainColor}
                            profileImage={Helper.getProfileImageUrlFromImageAPI(
                              Environment.getEnvironmentForImageAPI(this.props.peopleFinderStore.environment),
                              this.props.peopleFinderStore.tenantName,
                              this.props.peopleFinderStore.token,
                              person?.email
                            )}
                            name={person.displayName}
                            size={25}
                            fontSize={12}
                          />
                        </div>
                        <div className={styles.IA_peopleFinder_searchInputListCardProperties}>
                          <div
                            className={styles.IA_peopleFinder_searchInputListCardProperty}
                            dangerouslySetInnerHTML={{
                              __html: person.displayName?.replace(this.props.peopleFinderStore.searchValue, `<b>${this.props.peopleFinderStore.searchValue}</b>`) || '',
                            }}
                          />
                          <div
                            className={styles.IA_peopleFinder_searchInputListCardProperty}
                            dangerouslySetInnerHTML={{
                              __html: person.jobTitle?.replace(this.props.peopleFinderStore.searchValue, `<b>${this.props.peopleFinderStore.searchValue}</b>`) || '',
                            }}
                          />
                        </div>
                        <div className={styles.IA_peopleFinder_searchInputListCardfeatures}>
                          <div
                            className={styles.IA_peopleFinder_searchInputListCardfeature}
                            onClick={(v) => {
                              if (person.email) {
                                v.stopPropagation();
                                window.location.href = `mailto:${person.email}`;
                              }
                            }}
                          >
                            {person.email && <IAIcon title="Email" size={20} color={this.props.peopleFinderStore.design.colors.iconColor} />}
                            {!person.email && <div style={{ width: 20 }} />}
                          </div>
                          <div
                            className={styles.IA_peopleFinder_searchInputListCardfeature}
                            onClick={(v) => {
                              if (person.mobilePhone) {
                                v.stopPropagation();
                                window.location.href = `tel:${person.mobilePhone}`;
                              }
                            }}
                          >
                            {person.mobilePhone && <IAIcon title="Phone" size={20} color={this.props.peopleFinderStore.design.colors.iconColor} />}
                            {!person.mobilePhone && <div style={{ width: 20 }} />}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className={styles.IA_peopleFinder_searchInputListShowMoreAndSpinnerWrapper}>
                    {this.props.peopleFinderStore.isFetchingSearchResults && (
                      <div className={styles.IA_peopleFinder_searchInputListCardSpinner} style={{ padding: "5px 0px" }}>
                        <IAIcon title="Spinner" size={20} color={this.props.peopleFinderStore.design.colors.iconColor} />
                      </div>
                    )}
                    {!this.props.peopleFinderStore.isFetchingSearchResults && searchResult?.length === 10 && (
                      <div
                        className={styles.IA_peopleFinder_searchInputListCardShowMoreButton}
                        style={{ color: this.props.peopleFinderStore.design.colors.iconColor }}
                        onClick={() => {
                          this.props.peopleFinderStore.showResultsInFullView();
                        }}
                      >
                        {new LocalizationService().strings.PeopleFinder_ShowMore}
                      </div>
                    )}
                    {!this.props.peopleFinderStore.isFetchingSearchResults && searchResult?.length === 0 && (
                      <div className={styles.IA_peopleFinder_searchInputListNothingWasFound} style={{ color: this.props.peopleFinderStore.design.colors.iconColor }}>
                        {new LocalizationService().strings.PeopleFinder_NothingWasFound}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
